import React from 'react';
import { DownloadIcon, InfinityIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { IMAGES } from '../../data/content';
const badges = [{
  icon: DownloadIcon,
  label: 'Descarga inmediata'
}, {
  icon: CreditCardIcon,
  label: 'Pago único'
}, {
  icon: InfinityIcon,
  label: 'Acceso de por vida'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}];
export function FinalCTA() {
  return <section className="w-full bg-navy-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-153" data-mp="3huxibcx0h0kx">
      <div className="mx-auto w-full max-w-content" data-id="element-154" data-mp="33v5y2ufwinyh">
        <h2 className="text-balance text-center font-serif text-[27px] font-extrabold leading-[1.13] tracking-tight text-white sm:text-4xl md:text-[44px]" data-id="element-155" data-mp="33wh3eyozw3rp">
          La próxima decisión clínica llegará antes de lo que{' '}
          <span className="italic text-brand-light" data-id="element-156" data-mp="121q71wfwj72z">imaginas</span>.
        </h2>

        <p className="mx-auto mt-4 max-w-lg text-balance text-center text-[15px] leading-relaxed text-white/70 sm:text-[17px]" data-id="element-157" data-mp="171uoppsjq7us">
          La diferencia es que esta vez tendrás un sistema que te ayudará a responder con mayor
          seguridad, rapidez y claridad.
        </p>

        <img src={IMAGES.bundle} alt="Sistema de Decisión Clínica para Diabetes completo" className="mx-auto mt-7 w-full max-w-sm" loading="lazy" data-id="element-158" data-mp="yznitd0oo18j" />

        <div className="mt-4 rounded-2xl border border-white/10 bg-white/[0.06] px-4 py-4 text-center" data-id="element-159" data-mp="7asu5wwb0aas">
          <p className="text-[12px] font-extrabold uppercase tracking-[0.14em] text-white/60" data-id="element-160" data-mp="2bzmwm7m1fj2">
            Precio de lanzamiento
          </p>
          <p className="mt-1 flex items-end justify-center gap-2" data-id="element-161" data-mp="g8367kgy43gr">
            <span className="font-serif text-xl font-bold text-white/40 line-through" data-id="element-162" data-mp="b9t9v6jhiwtk">$237</span>
            <span className="font-serif text-[54px] font-black leading-[0.85] text-white sm:text-[64px]" data-id="element-163" data-mp="1ro1idx7f75m7">
              $15
            </span>
            <span className="pb-2 text-[13px] font-bold text-white/50" data-id="element-164" data-mp="kddjg37dn3q5">USD</span>
          </p>
          <p className="mt-1.5 text-[12px] font-semibold text-white/55" data-id="element-165" data-mp="pc6k2v1kf08w">
            Cambio de moneda automático según tu país
          </p>
        </div>

        <div className="mt-5" data-id="element-166" data-mp="tebdpts0jwvj">
          <CTAButton label="✅ Sí, quiero acceder ahora al Sistema" data-id="element-167" data-mp="tbyznrpdm6nr" />
        </div>

        <div className="mt-4" data-id="element-168" data-mp="yc3df9ywgnaa">
          <CountdownTimer tone="dark" data-id="element-169" data-mp="1mvt25a0ok7y" />
        </div>

        <ul className="mx-auto mt-5 grid max-w-md grid-cols-2 gap-x-3 gap-y-2.5" data-id="element-170" data-mp="1o6xm7badw04">
          {badges.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-1.5 text-[12px] font-semibold text-white/65" data-id="element-171" data-mp="anagba6jk9e3">
              <Icon className="h-3.5 w-3.5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-172" data-mp="fesj83s4kk1p" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}